var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    _vm._g(
      {
        attrs: {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
      },
      _vm.$listeners
    ),
    [
      _c("path", {
        attrs: {
          d: "M22 8V6a2 2 0 00-2-2H4a2 2 0 00-2 2v2a2 2 0 002 2h16a2 2 0 002-2z",
          fill: "#037889",
        },
      }),
      _c("path", {
        attrs: {
          d: "M22 18v-2a2 2 0 00-2-2H4a2 2 0 00-2 2v2a2 2 0 002 2h16a2 2 0 002-2z",
          fill: "#68AEB8",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }